import { fork } from 'redux-saga/effects';

import * as necessaryData from './requests/necessary-data-preparing-req';
import * as acceptConsent from './requests/accept-consent-req';
import * as careUsers from './requests/care-users-req';
import * as userDetails from './requests/user-details-req';
import * as visitTypes from './requests/visit-types-req';
import * as reasonTypes from './requests/reason-types-req';
import * as reasonVisit from './requests/reason-visit-req';
import * as programBasedVisits from './requests/program-based-visits-req';
import * as inspection from './requests/inspection-req';
import * as consent from './requests/consent-req';
import * as inspectPatient from './requests/inspect-patient-form';
import * as inspectConsent from './requests/inspect-consent-form';
import * as providerGWDetails from './requests/provider-GW-details-req';
import * as providerDetails from './requests/provider-details-req';
import * as schedulings from './requests/schedulings-req';
import * as availableProvidersSelfScheduling from './requests/available-providers-self-scheduling';
import * as confirmVisitSelfScheduling from './requests/confirm-visit-selfScheduling-req';
import * as confirmVisitUrgent from './requests/confirm-visit-urgent-req';
import * as confirmVisitGW from './requests/confirm-visit-GW-req';
import * as filterList from './requests/filters-req';
import * as organizations from './requests/organizations-req';
import * as virtualVisitProviders from './requests/virtual-visit-providers-req';
import * as publixInfo from './requests/publix-info-req';
import * as createVirtualVisit from './requests/create-virtual-visit-req';
import * as inspectVirtualVisit from './requests/inspection-virtual-visit-form';
import * as insurancePayers from './requests/insurance-payers-req';
import * as checkInsuranceEligibility from './requests/check-insurance-eligibility';
import * as latestCheckInsuranceEligibility from './requests/latest-check-insurance-req';
import * as checkInsurancePlanConfig from './requests/check-insurance-plan-config-req';
import * as pharmaciesList from './requests/pharmacy-req';
import * as medicationsList from './requests/medications-req';
import * as inlineVisitTimeSlots from './requests/inline-visits-time-slots';
import * as confirmInlineVisit from './requests/confirm-inline-visit';
import * as schedulingTree from './requests/schedulable-tree-req';
import * as myProviders from './requests/my-providers-req';
import updateNecessaryData from './sagas/update-data-saga';
import validateOnMount from './sagas/validate-on-mount-saga';
import inspectAllSaga from './sagas/inspectAll-saga';
import inspectConsentSaga from './sagas/inspect-consent-saga';
import inspectPatientSaga from './sagas/inspect-patient-saga';
import confirmAppointmentSaga from './sagas/confirm-appointment-saga';
import fetchProvidersSaga from './sagas/fetch-providers-saga';
import addVirtualVisitSaga from './sagas/add-virtual-visit-saga';
import visitTypeListGuard from './sagas/visit-type-list-guard-saga';
import confirmUrgentVisitSaga from './sagas/confirm-visit-urgent-saga';
import organizationListGuard from './sagas/organization-list-guard-saga';
import checkInsuranceEligibilitySaga from './sagas/check-insurance-saga';
import PharmacyMoreSaga from './sagas/more-pharmacies-saga';
import loadMoreMedicationsSaga from './sagas/more-medications-saga';
import getAvailableTimeSlots from './sagas/inline-visits-time-slots-saga';
import myProvidersListPagination from './sagas/my-providers-pagination-saga';
import repeatableScheduleFlow from './sagas/repeatable-schedule-flow-saga';
import myProvidersListGuard from './sagas/my-providers-list-guard-saga';
import * as fetchCopay from './requests/fetch-copay';
import handleInsuranceSucceedUpdate from './sagas/handle-insurance-succeed-update';
import handleInsuranceUpdateFailed from './sagas/handle-insurance-update-failed';
import { watcher as availableEirLocationsWatcher } from './requests/available-eir-locations';
import { watcher as createEirUrgentCareAppointment } from './requests/create-eir-urgent-care-appointment';
import { watcher as getPrimaryCareProvidersList } from './requests/primary-providers-list';
import { watcher as getPrimaryCareProviderData } from './requests/primary-provider-data';
import { watcher as getEmployersList } from './requests/organization-employers-list';

export default function* appointmentFormRootSaga() {
  yield fork(necessaryData.watcher);
  yield fork(acceptConsent.watcher);
  yield fork(careUsers.watcher);
  yield fork(userDetails.watcher);
  yield fork(visitTypes.watcher);
  yield fork(reasonTypes.watcher);
  yield fork(reasonVisit.watcher);
  yield fork(inspection.watcher);
  yield fork(consent.watcher);
  yield fork(inspectPatient.watcher);
  yield fork(inspectConsent.watcher);
  yield fork(providerGWDetails.watcher);
  yield fork(providerDetails.watcher);
  yield fork(schedulings.watcher);
  yield fork(confirmVisitSelfScheduling.watcher);
  yield fork(confirmVisitUrgent.watcher);
  yield fork(confirmVisitGW.watcher);
  yield fork(filterList.watcher);
  yield fork(organizations.watcher);
  yield fork(virtualVisitProviders.watcher);
  yield fork(publixInfo.watcher);
  yield fork(createVirtualVisit.watcher);
  yield fork(inspectVirtualVisit.watcher);
  yield fork(availableProvidersSelfScheduling.watcher);
  yield fork(programBasedVisits.watcher);
  yield fork(insurancePayers.watcher);
  yield fork(checkInsurancePlanConfig.watcher);
  yield fork(checkInsuranceEligibility.watcher);
  yield fork(latestCheckInsuranceEligibility.watcher);
  yield fork(pharmaciesList.watcher);
  yield fork(medicationsList.watcher);
  yield fork(inlineVisitTimeSlots.watcher);
  yield fork(confirmInlineVisit.watcher);
  yield fork(schedulingTree.watcher);
  yield fork(myProviders.watcher);
  yield fork(myProviders.paginationWatcher);
  yield fork(getAvailableTimeSlots);
  yield fork(organizationListGuard);
  yield fork(updateNecessaryData);
  yield fork(validateOnMount);
  yield fork(inspectAllSaga);
  yield fork(inspectConsentSaga);
  yield fork(inspectPatientSaga);
  yield fork(confirmAppointmentSaga);
  yield fork(fetchProvidersSaga);
  yield fork(addVirtualVisitSaga);
  yield fork(visitTypeListGuard);
  yield fork(confirmUrgentVisitSaga);
  yield fork(checkInsuranceEligibilitySaga);
  yield fork(PharmacyMoreSaga);
  yield fork(loadMoreMedicationsSaga);
  yield fork(myProvidersListPagination);
  yield fork(repeatableScheduleFlow);
  yield fork(myProvidersListGuard);
  yield fork(fetchCopay.watcher);
  yield fork(handleInsuranceSucceedUpdate);
  yield fork(handleInsuranceUpdateFailed);
  yield fork(availableEirLocationsWatcher);
  yield fork(createEirUrgentCareAppointment);
  yield fork(getPrimaryCareProvidersList);
  yield fork(getPrimaryCareProviderData);
  yield fork(getEmployersList);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/root-saga.js